import React, { FC, useContext } from 'react';
import { OrganizationInvitesFetcher } from '../../fetchers/OrganizationInvitesFetcher';
import { useAutoFetch } from '../../contexts/Fetcher';
import { InvitesTable } from '../Invites/InvitesTable';
import { InviteButton } from '../Invites/InviteButton';
import Box from '@mui/system/Box';

export const OrganizationInvites: FC = () => {
  const { data, onRefresh } = useContext(OrganizationInvitesFetcher.Context);

  useAutoFetch(OrganizationInvitesFetcher);

  if (!data) return null;

  return (
    <div>
      <Box mt={2} mb={2}>
        <InviteButton />
      </Box>

      <InvitesTable data={data.payload} onRefresh={onRefresh} />
    </div>
  );
};
